import React, { useMemo } from 'react';
import { useAtomValue, useAtom } from 'jotai';
import * as atoms from '../atom';
import * as Styled from './styled';
import { generateAllCategory, isAllCategory } from '../../utils';

const allCategory = generateAllCategory();

export const DimensionCategory = () => {
  const filterMeta = useAtomValue(atoms.filterMeta);
  const [currentCategory, setcurrentCategory] = useAtom(atoms.currentCategory);

  const categories = useMemo(() => {
    const menus = [{
      key: allCategory.category,
      label: <Styled.MenuLabel>ALL</Styled.MenuLabel>,
    }];

    for (const [category, subCategories] of Object.entries(filterMeta.categories)) {
      const item = {
        key: category,
        label: <Styled.MenuLabel>{category}</Styled.MenuLabel>,
        children: subCategories.map(it => ({
          key: it,
          label: <Styled.SubMenuLabel>{it}</Styled.SubMenuLabel>,
        })).sort((a, b) => String(a.key).localeCompare(String(b.key)))
      };
      menus?.push(item);
    }
    return menus.sort((a, b) => String(a.key).localeCompare(String(b.key)))
  }, [filterMeta]);

  const selectedKeys = useMemo(() => {
    return isAllCategory(currentCategory.category) ? [currentCategory.category] : [currentCategory.subCategory];
  }, [currentCategory]);

  return (
    <Styled.Menu
      mode="inline"
      items={categories}
      selectedKeys={selectedKeys}
      defaultOpenKeys={[currentCategory.category]}
      onClick={({ keyPath, key }) => {
        if (isAllCategory(key)) {
          // select all category
          setcurrentCategory({
            category: allCategory.category,
            subCategory: allCategory.subCategory
          });
        } else {
          // select other category
          setcurrentCategory({
            category: keyPath[1],
            subCategory: keyPath[0]
          });
        }
      }}
    />
  )
};